export default "__VITE_ASSET__ca54d1a8__"